import { createSelector } from "reselect"
import { get, find } from "lodash"
import { CATEGORIES, BETA_FACTORS, CONCENTRATION_FACTORS } from "helpers/analyzeConstants"

export const getDisabled = state => get(state, "modules.securityProfileComposition.disabled")
export const getRawDisplayType = state => get(state, "modules.securityProfileComposition.displayType")

export const getDisplayType = createSelector(
  [getRawDisplayType],
  (displayType) => {
    if (find(CATEGORIES, cat => cat.id === displayType)) {
      return displayType
    }
    return CATEGORIES[0].id
  },
)

export const getDisplayTypeName = createSelector(
  [getRawDisplayType],
  (displayType) => {
    const category = find(CATEGORIES, cat => cat.id === displayType)
    if (category) {
      return category.label
    }

    return CATEGORIES[0].label
  },
)

export const getFactors = createSelector(
  [getRawDisplayType],
  (displayType) => displayType === "beta" ? BETA_FACTORS : CONCENTRATION_FACTORS,
)
